import { BaseChart } from "./BaseChart";
import { TimePeriod } from "./TimePeriodSelector";
import type { TemperatureResponse } from "@/types/tracker";
import { processSimpleTrackerChartData } from "./utils";
import { getMetricColor } from "./chart-theme";

interface TemperatureChartProps {
  data: TemperatureResponse | null;
  selectedPeriod: TimePeriod;
  currentDate: Date;
}

export const TemperatureChart = ({
  data,
  selectedPeriod,
  currentDate,
}: TemperatureChartProps) => {
  const apiMin = data?.y_axis?.min ?? 30;
  const apiMax = data?.y_axis?.max ?? 110;
  const flooredMin = Math.floor(apiMin);
  const ceiledMax = Math.ceil(apiMax);
  const computedRange = ceiledMax - flooredMin;
  const yAxisConfig = {
    min: flooredMin,
    max: ceiledMax,
    customInterval: computedRange < 150 ? 10 : 20,
  };

  const chartData = processSimpleTrackerChartData(
    data,
    selectedPeriod,
    currentDate
  );

  return (
    <BaseChart
      data={chartData}
      selectedPeriod={selectedPeriod}
      currentDate={currentDate}
      yAxisConfig={yAxisConfig}
      chartColor={getMetricColor("temperature")}
      metricName="Temperature"
      unit="°F"
    />
  );
};
